module.exports = __webpack_public_path__ + "static/Widget-eb9f603087a7c5f8bec2ecaa3da5e651.png";